<template>
  <div class="calendar_box">
    <full-calendar ref="fullCalendar" style="height: 100%" :options="calendarOptions">
      <template v-slot:eventContent="arg">
        <el-row>
          <el-col :span="14">{{ arg.timeText }}</el-col>
          <el-col :span="7">{{ arg.event.extendedProps.create_user_name }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">主题：</el-col>
          <el-col :span="19">{{ arg.event.title }}</el-col>
        </el-row>
      </template>
    </full-calendar>
    <div class="my_toolbar">
      <el-select v-model="roomNo" placeholder="会议室选择" class="toolbar_item" style="width: 130px" >
        <el-option v-for="item in conferenceName" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="selectConference" class="toolbar_item">查询</el-button>
      <el-button type="primary" @click="addConference" class="toolbar_item">添加预约</el-button>
    </div>
  </div>

  <el-dialog title="会议室预约" v-model="dialogFormVisible" width="30%">
    <el-form :model="formData" label-width="100px" :rules="rules">
      <el-form-item label="会议室：" prop="star">
        <el-select v-model="roomNo" placeholder="会议室选择" class="toolbar_item" style="width: 250px">
          <el-option v-for="item in conferenceName" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预约日期：" prop="star">
        <FrameItem
            v-model="formData.borrow_data"
            :item="dataItemJson"
            style="width: 250px"
        ></FrameItem>
      </el-form-item>
      <el-form-item label="会议主题：" prop="star">
        <el-input v-model="formData.theme" style="width: 250px" placeholder="请输入会议主题" clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="部门：">
        <el-select v-model="formData.department_id" placeholder="部门选择" class="toolbar_item" multiple style="width: 250px">
          <el-option v-for="item in departmentName" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参会人员：">
        <el-select v-model="formData.participant" placeholder="人员选择" class="toolbar_item" multiple style="width: 250px">
          <el-option v-for="item in userName" :key="item.id" :label="item.full_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间：" prop="star">
        <el-time-select
            v-model="formData.start_time"
            start="08:00"
            step="00:30"
            end="22:00"
            placeholder="请选择时间"
            style="width: 250px"
        />
      </el-form-item>
      <el-form-item label="结束时间：" prop="star">
        <el-time-select
            v-model="formData.end_time"
            start="08:00"
            step="00:30"
            end="22:00"
            placeholder="请选择时间"
            style="width: 250px"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="submit" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="会议室预约详情" v-model="dialogFormDataVisible" width="30%">
    <el-row>
      <el-col :span="6" class="item-text">会议室：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.conference_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">预约日期：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.borrow_data }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">会议主题：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.theme }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">部门：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.create_user_name_list }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">参会人员：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.user_name_list }}</el-col>
    </el-row>

    <el-row>
      <el-col :span="6" class="item-text">开始时间：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.start_time }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">结束时间：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.end_time }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="item-text">预约人：</el-col>
      <el-col :span="18" class="item-value">{{ formAllData.create_user_name }}</el-col>
    </el-row>

    <el-button class="deleteButton" @click="deleteConference" type="danger"
               v-if="this.$store.state.core.currentUser?.id == formAllData.create_user_id
               || this.$store.state.core.currentUser?.id =='U0001'">删除
    </el-button>

  </el-dialog>
</template>
<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment/moment'

moment.locale('zh-cn')

export default {
  name: 'ConferenceReservation',
  components: {
    FullCalendar,
  },
  data() {
    return {
      dataItemJson: {
        component: 'date_picker',
        placeholder: "请选择日期",
        date_range: '0,7'
      },
      loading: false,
      dialogFormDataVisible: false,
      dialogFormVisible: false,
      roomNo: '',
      conferenceName: [],
      departmentName: [],
      formData: {
        conference_id: '',
        theme: '',
        department_id: [],
        participant: [],
        borrow_data: '',
        start_time: '',
        end_time: '',
      },
      formAllData: {},
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
      calendarOptions: {
        buttonText: {
          // 设置按钮
          today: "今天",
          week: "周",
          list: "列表",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        customButtons: {
          next: {
            click: this.nextClick
          },
          prev: {
            click: this.prevClick
          },
          today: {
            text: "今天",
            click: this.todayClick
          },
        },
        headerToolbar: {
          left: "prev,next,today",
          center: "title",
          right: ""

        },
        aspectRatio: 3.09,
        weekMode: "variable",
        allDaySlot: false,
        selectable: true,
        weekends: true,//是否显示周末
        //selectMirror: true,
        navLinks: true,
        displayEventEnd: true,//所有视图显示结束时间
        initialView: "timeGridWeek", // 设置默认显示月，可选周、日
        // select: this.handleDateSelect,//
        eventClick: this.handleEventClick,//删除
        // 设置日程
        events: [],
        locale: "zh-Cn", // 设置语言
        weekNumberCalculation: "ISO", // 周数
      },
    };
  },
  created() {
    this.getConferenceName()
    this.getDepartmentName()
    this.getUserName()
  },
  methods: {
    windowResize() {
      this.$refs.fullCalendar.getApi().updateSize()
    },
    nextClick() {
      this.$refs.fullCalendar.getApi().next()
      this.selectConference()
    },

    prevClick() {
      this.$refs.fullCalendar.getApi().prev()
      this.selectConference()
    },

    todayClick() {
      this.$refs.fullCalendar.getApi().today()
      this.selectConference()
    },

    addConference() {
      this.dialogFormVisible = true;
    },
    handleEventClick(clickInfo) {
      this.dialogFormDataVisible = true;
      this.$axios.post('/oa/conference/getConferenceDetail', clickInfo.event.id).then(response => {
        let res = response.data
        this.formAllData = res

      })
    },
    submit() {
      this.formData.conference_id = this.roomNo

      if (!this.formData.conference_id) {
        return this.$message({
          type: 'error',
          message: '会议室不能为空!'
        })
      }
      if (!this.formData.borrow_data) {
        return this.$message({
          type: 'error',
          message: '预约日期不能为空!'
        })
      }
      if (!this.formData.theme) {
        return this.$message({
          type: 'error',
          message: '会议主题不能为空!'
        })
      }
      if (this.formData.department_id.length <= 0 && this.formData.participant.length <= 0) {
        return this.$message({
          type: 'error',
          message: '部门和参会人员至少填一个!'
        })
      }
      if (!this.formData.start_time) {
        return this.$message({
          type: 'error',
          message: '开始时间不能为空!'
        })
      }
      if (!this.formData.end_time) {
        return this.$message({
          type: 'error',
          message: '结束时间不能为空!'
        })
      }

      this.loading = true;
      this.formData.borrow_data = moment(new Date(this.formData.borrow_data)).format('yyyy-MM-DD')
      this.$axios.post('/oa/conference/addConference', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(res.message);
        }
        this.formData.borrow_data = ''
        this.formData.start_time = ''
        this.formData.end_time = ''
        this.formData.theme = ''
        this.formData.department_id = []
        this.formData.participant = []
        this.dialogFormVisible = false;

        this.selectConference();
        return this.$message({
          type: 'success',
          message: '提交成功!'
        });
      })
    },
    deleteConference() {
      this.dialogFormDataVisible = false
      this.$confirm('你确定要删除，预约会议主题为【' + this.formAllData.theme + '】的会议吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/oa/conference/deleteConference', this.formAllData.id).then(response => {
          let res = response.data
          if (res.code != 0) {
            return this.$message({
              type: 'error',
              message: '删除失败!'
            });
          }
          this.selectConference();
          return this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    selectConference() {
      this.$axios.post('/oa/conference/getConferenceAll', this.roomNo).then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message({
            type: 'error',
            message: '查询失败!'
          });
        }
        this.calendarOptions.events = res.data.itemList

      })
    },

    //获取会议室
    getConferenceName() {
      this.$axios.post('/oa/conference/getConferenceRoom').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message({
            type: 'error',
            message: '获取失败!'
          });
        }
        this.conferenceName = res.data.itemList;
        this.roomNo = res.data.itemList[0].id;
        this.selectConference()
      })
    },
    //获取部门
    getDepartmentName() {
      this.$axios.post('/oa/conference/getDepartmentName').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message({
            type: 'error',
            message: '获取失败!'
          });
        }
        this.departmentName = res.data.itemList;
      })
    },
    //获取人员
    getUserName() {
      this.$axios.post('/oa/conference/getUserAll').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message({
            type: 'error',
            message: '获取失败!'
          });
        }
        this.userName = res.data.itemList;
      })
    },
  },

}

</script>

<style lang="less" scoped>

.calendar_box {
  width: 100%;
  height: 80%;
  padding: 20px;
}

.my_toolbar {
  position: absolute;
  top: 25px;
  right: 100px;
  text-align: left;
  line-height: 40px;
  vertical-align: middle;
  /*border: 1px dotted lightgray;*/
  display: inline-flex;

}

.toolbar_item {
  margin-right: 10px;
}

.item-text {
  text-align: right;
  font-size: 20px;
  line-height: 40px;
}

.item-value {
  font-size: 20px;
  line-height: 40px;

}

.deleteButton {
  margin-left: 130px;
}


</style>
